import React from "react";
import CollectionsSection from "../../Component/Home/CollectionsSection";
import ServicesSection from "../../Component/Home/ServicesSection";
import SafetySection from "../../Component/Home/SafetySection";

import Slider from "./Landingpage/Sliderss";

const Landingpagess = () => {
  return (
    <>
    
      <Slider />
      <CollectionsSection />
      <ServicesSection />
      <SafetySection />
      {/* <ExploreSection /> */}
    </>
  );
};

export default Landingpagess;